/* THE LEADERSHIP IMPRINT — Facilitator dashboard.
   One page, many companies: the cohort id + facilitator token ride in the URL
   hash (#c=…&t=…). A PIN gates the first open. Reads /apps/p2p/li (roster) and
   renders live completion stats, a team-spread preview, and who to chase.
   No Shopify account required. */
(function (root) {
  'use strict';
  var PROXY = '/apps/p2p/li';
  var SHEX = { TRACTOR: '#C87F0A', BUS: '#2E8B45', JET: '#1B3F8B', ROCKET: '#C41E1E' };
  var SLAB = { TRACTOR: 'Tractor', BUS: 'Bus', JET: 'Jet', ROCKET: 'Rocket' };
  var ORDER = ['TRACTOR', 'BUS', 'JET', 'ROCKET'];

  function el(t, a, k) { var e = document.createElement(t); if (a) Object.keys(a).forEach(function (x) { if (x === 'text') e.textContent = a[x]; else if (x === 'html') e.innerHTML = a[x]; else e.setAttribute(x, a[x]); }); (k || []).forEach(function (c) { if (c) e.appendChild(c); }); return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
  function hashParams() { var h = (location.hash || '').replace(/^#/, ''); var o = {}; h.split('&').forEach(function (p) { var kv = p.split('='); if (kv[0]) o[kv[0]] = decodeURIComponent(kv[1] || ''); }); return o; }
  function fmtDate(ts) { if (!ts) return '—'; try { return new Date(ts).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch (e) { return '—'; } }
  function fmtDur(ms) { if (!ms) return '—'; var s = Math.round(ms / 1000); var m = Math.floor(s / 60); return m > 0 ? m + 'm ' + (s % 60) + 's' : s + 's'; }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/·.*$/g, '').replace(/\([^)]*\)/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  // A roster entry matches a session if names line up, tolerant of a first-name-only
  // roster vs a "First Last" entry, or extra middle/last names either way.
  function nameMatches(rosterName, sessionName) {
    var r = norm(rosterName), s = norm(sessionName);
    if (!r || !s) return false;
    if (r === s) return true;
    var rt = r.split(' '), st = s.split(' ');
    if (rt.length === 1) return st.indexOf(rt[0]) >= 0;               // first-name-only roster
    if (st.length === 1) return rt.indexOf(st[0]) >= 0;               // first-name-only entry
    return st[0] === rt[0] && st[st.length - 1] === rt[rt.length - 1]; // first + last
  }
  function slug(s) { return String(s || 'cohort').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'cohort'; }
  function downloadBlob(text, mime, filename) {
    var blob = new Blob([text], { type: mime }); var url = URL.createObjectURL(blob);
    var a = document.createElement('a'); a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  function mount(hostEl) {
    var hp = hashParams();
    var cohort = (hp.c || '').replace(/[^a-z0-9]/gi, '');
    var token = (hp.t || '').replace(/[^a-z0-9]/gi, '');
    var store = 'lifac:' + cohort;
    var pin = sessionStorage.getItem(store) || '';

    if ('new' in hp) return createForm(hostEl);
    if (!cohort || !token) { return gate(hostEl, 'This dashboard link is incomplete. Use the exact link from your purchase email.', true); }
    if (!pin) return askPin(hostEl, cohort, token, store);
    load(hostEl, cohort, token, pin, store);
  }

  /* Admin-only cohort minting (open the dashboard page with #new). Useless without
     the owner key (li_admin), which the Worker validates — so it is safe to expose.
     Three keys, three jobs: owner key = you (creates the run); company access code =
     employees type it to start; facilitator key = the point person opens the dashboard. */
  function createForm(hostEl) {
    hostEl.innerHTML = '';
    // labelled field with optional required-asterisk, help line and a show/hide eye
    function fld(label, opts) {
      opts = opts || {};
      var i = el('input', { class: 'fac-input', type: (opts.secret ? 'password' : (opts.type || 'text')), placeholder: opts.ph || '' });
      i.style.textAlign = 'left'; i.style.letterSpacing = 'normal'; i.style.fontSize = '15px';
      if (opts.secret) i.style.paddingRight = '44px';
      var lab = el('span', {}, [document.createTextNode(label)]);
      if (opts.req) lab.appendChild(el('b', { class: 'fac-req', text: ' *' }));
      var kids = [lab];
      var wrap = i;
      if (opts.secret) {
        var eye = el('button', { class: 'fac-eye', type: 'button', 'aria-label': 'Show or hide' , text: '👁' });
        eye.addEventListener('click', function () { i.type = (i.type === 'password' ? 'text' : 'password'); eye.classList.toggle('on', i.type === 'text'); });
        wrap = el('span', { class: 'fac-eyewrap' }, [i, eye]);
      }
      kids.push(wrap);
      if (opts.help) kids.push(el('span', { class: 'fac-help', text: opts.help }));
      return { row: el('label', { class: 'fac-field' }, kids), input: i };
    }

    var company = fld('Company name', { ph: 'e.g. Northwind Group', req: true });
    var seats = fld('Seats (number of leaders)', { ph: 'e.g. 25', type: 'number', req: true });
    var owner = fld('Owner key', { ph: 'Your private BSC key', secret: true, req: true, help: 'Yours only. This is the key you set in Cloudflare — it is never shared with the company.' });
    var access = fld('Company access code', { ph: 'e.g. acme2026', secret: true, help: '8+ characters, letters and numbers, not case-sensitive. Employees type this to start. Leave blank for no code.' });
    var fackey = fld('Facilitator dashboard key', { ph: 'Leave blank for an auto PIN', secret: true, help: 'Only the company’s point person uses this to open the results dashboard. Keep it separate from the access code above.' });

    // roster: (i) guidance, CSV template, upload + paste
    var roster = el('textarea', { class: 'fac-input', rows: '6', placeholder: 'One person per line:\nMike, Dann, 1042\nAndrea, Ives\n(First name, Last name, optional Employee #)' });
    roster.style.textAlign = 'left'; roster.style.letterSpacing = 'normal'; roster.style.fontSize = '14px';
    var fileInput = el('input', { type: 'file', accept: '.csv,.txt', class: 'fac-file' });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0]; if (!f) return;
      var rd = new FileReader();
      rd.onload = function () { roster.value = csvToLines(String(rd.result || '')); note.textContent = 'Loaded names from ' + f.name + '.'; };
      rd.readAsText(f);
    });
    var tmpl = el('button', { class: 'fac-link', type: 'button', text: 'Download CSV template' });
    tmpl.addEventListener('click', function () {
      var blob = new Blob(['First Name,Last Name,Employee Number\nMike,Dann,1042\nAndrea,Ives,\n'], { type: 'text/csv' });
      var u = URL.createObjectURL(blob); var a = document.createElement('a'); a.href = u; a.download = 'imprint-roster-template.csv';
      document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(function () { URL.revokeObjectURL(u); }, 3000);
    });
    var upl = el('label', { class: 'fac-upl' }, [el('span', { class: 'fac-upl-btn', text: 'Upload CSV of names' }), fileInput]);
    var rosterHelp = el('div', { class: 'fac-rosterhelp' }, [
      el('p', { class: 'fac-help', html: '<b>How to fill this in:</b> one person per line — <i>First name, Last name, optional Employee #</i>, separated by commas. Or upload a CSV (export from Excel with <i>Save As → CSV</i>). This only powers your “who hasn’t finished” list.' }),
      el('p', { class: 'fac-privacy', text: 'Privacy: we never use, share, sell, or contact anyone on this list. Names are used only to show which seats are done. We do not ask for email or phone.' })
    ]);

    var note = el('div', { class: 'fac-note' });
    var out = el('div', { class: 'fac-out' });
    var btn = el('button', { class: 'fac-btn', type: 'button', text: 'Create cohort' });
    btn.addEventListener('click', function () {
      var people = parseRoster(roster.value || '');
      if (!company.input.value.trim() || !seats.input.value || !owner.input.value) { note.textContent = 'Company, seats and owner key are required.'; return; }
      btn.disabled = true; note.textContent = 'Creating…';
      fetch(PROXY, { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ action: 'create', admin: owner.input.value, company: company.input.value.trim(), seats: parseInt(seats.input.value, 10),
          accessCode: access.input.value.trim(), pin: fackey.input.value.trim(), roster: people }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          btn.disabled = false;
          if (!d || !d.ok) { note.textContent = (d && d.error === 'unauthorized') ? 'Owner key not accepted — that is the value of your li_admin secret, not the word "li_admin".' : ((d && d.error) ? ('Failed: ' + d.error) : 'Failed. Check the owner key.'); return; }
          note.textContent = 'Cohort created.';
          // Build links off THIS dashboard page's own path so they always resolve,
          // wherever the pages live (e.g. under /pages/). Swap the trailing handle.
          var takePath = location.pathname.replace(/[^\/]+$/, 'leadership-imprint-company-take-link');
          var take = location.origin + takePath + '?c=' + encodeURIComponent(d.cohortId);
          var dash = location.origin + location.pathname + '#c=' + d.cohortId + '&t=' + d.facToken;
          out.innerHTML = '<div class="fac-eyebrow" style="margin-top:18px;">' + esc(d.company) + ' · ' + d.seats + ' seats</div>' +
            '<p class="fac-out-lab">1 · Company link — share with the team</p><code class="fac-code">' + esc(take) + '</code>' +
            (d.accessCode ? '<p class="fac-out-lab">2 · Access code — employees type this to start</p><code class="fac-code fac-pin">' + esc(d.accessCode) + '</code>' : '<p class="fac-fine">No access code set — the link alone starts the assessment.</p>') +
            '<p class="fac-out-lab">3 · Facilitator dashboard — your private link</p><code class="fac-code">' + esc(dash) + '</code>' +
            '<p class="fac-out-lab">4 · Facilitator key — opens the dashboard</p><code class="fac-code fac-pin">' + esc(d.pin) + '</code>' +
            '<p class="fac-fine">Save all four now. The access code and facilitator key are only shown here.</p>';
        })
        .catch(function () { btn.disabled = false; note.textContent = 'Could not reach the server.'; });
    });

    hostEl.appendChild(el('div', { class: 'fac-gate fac-create', style: 'max-width:560px;text-align:left;' }, [
      el('div', { class: 'fac-eyebrow', text: 'Owner · create a company run' }),
      el('h2', { text: 'New company run' }),
      el('p', { class: 'fac-help', html: 'Fields marked <b class="fac-req">*</b> are required.' }),
      company.row, seats.row,
      el('label', { class: 'fac-field' }, [el('span', { text: 'Expected roster (optional)' }), roster,
        el('div', { class: 'fac-rosterbar' }, [upl, tmpl]), rosterHelp]),
      access.row, fackey.row, owner.row, btn, note, out
    ]));
  }

  // "First, Last, 1042" (or "First Last") per line -> [{name, emp}]
  function parseRoster(text) {
    return String(text || '').split('\n').map(function (line) {
      var t = line.trim(); if (!t) return null;
      if (t.indexOf(',') >= 0) {
        var p = t.split(',').map(function (x) { return x.trim(); });
        var name = (p[0] + ' ' + (p[1] || '')).trim();
        return name ? { name: name, emp: p[2] || '' } : null;
      }
      return { name: t, emp: '' };
    }).filter(Boolean);
  }
  // raw CSV text -> textarea lines, skipping an obvious header row
  function csvToLines(csv) {
    var rows = csv.split(/\r?\n/).map(function (r) { return r.trim(); }).filter(Boolean);
    if (rows.length && /first|name|employee/i.test(rows[0]) && /,/.test(rows[0])) rows.shift();
    return rows.join('\n');
  }

  function gate(hostEl, msg, hard) {
    hostEl.innerHTML = '';
    hostEl.appendChild(el('div', { class: 'fac-gate' }, [
      el('div', { class: 'fac-eyebrow', text: 'Facilitator dashboard' }),
      el('h2', { text: hard ? 'Link problem' : 'Enter your access PIN' }),
      el('p', { class: 'fac-muted', text: msg })
    ]));
  }

  function askPin(hostEl, cohort, token, store) {
    hostEl.innerHTML = '';
    var inp = el('input', { class: 'fac-input', type: 'password', placeholder: 'Facilitator key', maxlength: '40' });
    inp.style.paddingRight = '44px';
    var eye = el('button', { class: 'fac-eye', type: 'button', 'aria-label': 'Show or hide', text: '👁' });
    eye.addEventListener('click', function () { inp.type = (inp.type === 'password' ? 'text' : 'password'); eye.classList.toggle('on', inp.type === 'text'); });
    var note = el('div', { class: 'fac-note' });
    var btn = el('button', { class: 'fac-btn', type: 'button', text: 'View dashboard' });
    function go() {
      var v = (inp.value || '').trim(); if (!v) { note.textContent = 'Enter your facilitator key.'; return; }
      btn.disabled = true; note.textContent = 'Checking…';
      fetchRoster(cohort, token, v).then(function (d) {
        if (d && d.ok) { sessionStorage.setItem(store, v); render(hostEl, cohort, token, v, store, d); }
        else { btn.disabled = false; note.textContent = 'That key did not match. Try again.'; }
      }).catch(function () { btn.disabled = false; note.textContent = 'Could not reach the server. Try again.'; });
    }
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });
    btn.addEventListener('click', go);
    hostEl.appendChild(el('div', { class: 'fac-gate' }, [
      el('div', { class: 'fac-eyebrow', text: 'Facilitator dashboard' }),
      el('h2', { text: 'Enter your facilitator key' }),
      el('p', { class: 'fac-muted', text: 'The key from your setup. It keeps this dashboard private to you.' }),
      el('span', { class: 'fac-eyewrap' }, [inp, eye]), btn, note
    ]));
    inp.focus();
  }

  function fetchRoster(cohort, token, pin) {
    return fetch(PROXY, { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ action: 'roster', c: cohort, t: token, pin: pin }) }).then(function (r) { return r.json(); });
  }

  function load(hostEl, cohort, token, pin, store) {
    hostEl.innerHTML = '<div class="fac-gate"><p class="fac-muted">Loading…</p></div>';
    fetchRoster(cohort, token, pin).then(function (d) {
      if (d && d.ok) render(hostEl, cohort, token, pin, store, d);
      else { sessionStorage.removeItem(store); askPin(hostEl, cohort, token, store); }
    }).catch(function () { gate(hostEl, 'Could not reach the server. Refresh to try again.', true); });
  }

  function render(hostEl, cohort, token, pin, store, d) {
    hostEl.innerHTML = '';
    var pct = d.seats ? Math.round((d.completed / d.seats) * 100) : 0;

    // header
    var head = el('div', { class: 'fac-head' }, [
      el('div', {}, [
        el('div', { class: 'fac-eyebrow', text: 'Leadership Imprint · Facilitator' }),
        el('h1', { class: 'fac-title', text: d.company || 'Your team' })
      ]),
      el('div', { class: 'fac-headbtns' }, [
        (function () { var b = el('button', { class: 'fac-btn fac-btn-ghost', type: 'button', text: 'Refresh' }); b.addEventListener('click', function () { load(hostEl, cohort, token, pin, store); }); return b; })(),
        (function () { var b = el('button', { class: 'fac-btn fac-btn-ghost', type: 'button', text: 'Download summary (CSV)' }); b.addEventListener('click', function () { csvSummary(d); }); return b; })(),
        (function () { var b = el('button', { class: 'fac-btn fac-btn-ghost', type: 'button', text: 'Download data (for workbooks)' }); b.addEventListener('click', function () { exportData(cohort, d.company); }); return b; })()
      ])
    ]);

    // Who has finished vs not — recomputed here (tolerant name matching) rather
    // than trusting the server's strict match, so "Jessica" == "Jessica Tester".
    var notStarted = (d.roster || []).filter(function (r) {
      return !(d.sessions || []).some(function (s) { return s.name && nameMatches(r, s.name); });
    });

    // stat tiles
    var tiles = el('div', { class: 'fac-tiles' }, [
      tile(d.completed + ' / ' + d.seats, 'Completed'),
      tile(String(pct) + '%', 'Of seats'),
      tile(String(d.started - d.completed), 'In progress / abandoned'),
      tile(String(d.roster && d.roster.length ? notStarted.length : Math.max(0, d.seats - d.started)), 'Not yet started')
    ]);
    var bar = el('div', { class: 'fac-progress' }, [el('span', { style: 'width:' + pct + '%' })]);

    // team imprint (style distribution of completed)
    var counts = { TRACTOR: 0, BUS: 0, JET: 0, ROCKET: 0 };
    (d.sessions || []).forEach(function (s) { if (s.complete && counts.hasOwnProperty(s.style)) counts[s.style]++; });
    var totalC = d.completed || 0;
    var spread = el('div', { class: 'fac-spread' }, ORDER.map(function (st) {
      var c = counts[st], w = totalC ? Math.round((c / totalC) * 100) : 0;
      return el('div', { class: 'fac-srow' }, [
        el('span', { class: 'fac-slab', style: 'color:' + SHEX[st], text: SLAB[st] }),
        el('span', { class: 'fac-strack' }, [el('span', { class: 'fac-sfill', style: 'width:' + w + '%;background:' + SHEX[st] })]),
        el('span', { class: 'fac-scount', text: String(c) })
      ]);
    }));

    // table
    var rows = (d.sessions || []).map(function (s) {
      var st = s.complete ? 'done' : (s.startedAt ? 'progress' : 'idle');
      return el('tr', {}, [
        el('td', { text: s.name || '—' }),
        el('td', { html: s.style ? '<span class="fac-pill" style="background:' + (SHEX[s.style] || '#666') + '">' + esc(SLAB[s.style] || s.style) + '</span>' : '<span class="fac-dash">—</span>' }),
        el('td', { class: 'fac-num', text: fmtDate(s.startedAt) }),
        el('td', { class: 'fac-num', text: fmtDate(s.completedAt) }),
        el('td', { class: 'fac-num', text: fmtDur(s.durationMs) }),
        el('td', { html: '<span class="fac-status fac-' + st + '">' + (st === 'done' ? 'Complete' : st === 'progress' ? 'In progress' : 'Not started') + '</span>' })
      ]);
    });
    var table = el('div', { class: 'fac-tablewrap' }, [
      el('table', { class: 'fac-table' }, [
        el('thead', {}, [el('tr', {}, ['Name', 'Style', 'Started', 'Completed', 'Time', 'Status'].map(function (h) { return el('th', { text: h }); }))]),
        el('tbody', {}, rows.length ? rows : [el('tr', {}, [el('td', { colspan: '6', class: 'fac-empty', text: 'No one has started yet. Share the company link.' })])])
      ])
    ]);

    // who to chase
    var chase = null;
    if (notStarted.length) {
      chase = el('div', { class: 'fac-chase' }, [
        el('div', { class: 'fac-eyebrow', text: 'Still to do · ' + notStarted.length }),
        el('p', { class: 'fac-muted', text: notStarted.join(' · ') })
      ]);
    }

    hostEl.appendChild(el('div', { class: 'fac' }, [head, tiles, bar,
      el('h3', { class: 'fac-h', text: "Team Imprint" }), spread,
      el('h3', { class: 'fac-h', text: 'Participants' }), table, chase,
      el('p', { class: 'fac-fine', text: 'Individuals do not see their own result. Completed workbooks and the Team Imprint are delivered for your session.' })
    ]));
  }

  function tile(big, label) {
    return el('div', { class: 'fac-tile' }, [el('div', { class: 'fac-big', text: big }), el('div', { class: 'fac-lab', text: label })]);
  }

  /* Readable, open-anywhere summary — built from data already on the page, so it
     needs no owner key. One row per person: who's done, their style, timing. */
  function csvSummary(d) {
    var rows = [['Name', 'Style', 'Started', 'Completed', 'Time', 'Status']];
    (d.sessions || []).forEach(function (s) {
      rows.push([s.name || '', s.style ? (SLAB[s.style] || s.style) : '', fmtDate(s.startedAt), fmtDate(s.completedAt), fmtDur(s.durationMs),
        s.complete ? 'Complete' : (s.startedAt ? 'In progress' : 'Not started')]);
    });
    var csv = rows.map(function (r) { return r.map(function (c) { var v = String(c == null ? '' : c); return /[",\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; }).join(','); }).join('\n');
    downloadBlob(csv, 'text/csv;charset=utf-8', 'imprint-summary-' + slug(d.company) + '.csv');
  }

  /* Owner-only full export (includes every response). The Worker gates this on
     the li_admin key, so the button is safe to show — it is inert without it.
     Downloads the raw cohort JSON, which the offline pack generator turns into
     each persons workbook + the Team Imprint. Not meant to be read directly. */
  function exportData(cohort, company) {
    var key = window.prompt('Owner key to download the full data file for this cohort (the value of your li_admin secret):');
    if (!key) return;
    fetch(PROXY, { method: 'POST', headers: { 'content-type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ action: 'export', c: cohort, admin: key }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) { window.alert((d && d.error === 'unauthorized') ? 'That owner key was not accepted.' : 'Export failed. Check the owner key.'); return; }
        downloadBlob(JSON.stringify(d, null, 2), 'application/json', 'imprint-results-' + slug(company || cohort) + '.json');
        window.alert('Saved the data file. This is the file that generates everyone’s workbooks and the Team Imprint — send it on to build the pack. For a quick readable view, use "Download summary (CSV)".');
      })
      .catch(function () { window.alert('Could not reach the server.'); });
  }

  root.TLI = root.TLI || {};
  root.TLI.facilitator = { mount: mount };
})(typeof window !== 'undefined' ? window : this);
